import { apiRequest } from '@/api/helpers/apiRequest';
import {
  type CreateStoryTemplateRequest,
  type CreateStoryTemplateSuccessResponse,
  CreateStoryTemplateResponseSchema,
} from 'schemas';
import { handleApiError } from '@/api/helpers/handleApiError';

export const createStoryTemplate = async (
  storyTemplateData: CreateStoryTemplateRequest
): Promise<CreateStoryTemplateSuccessResponse['data']> => {
  try {
    return await apiRequest(
      'POST',
      '/api/story-templates',
      storyTemplateData,
      CreateStoryTemplateResponseSchema
    );
  } catch (error) {
    handleApiError(error);
  }
};
